export default {
    description: 'For first time use, please read the user manuals carefully. Failure to do so may result in injury, property damage and may void warranty.',
    title: 'ACE Ebike User Manual',
    content: 'This user manual contains necessary information you need for your first ride on ACE ebike, including safety warnings, folding instructions, trouble shootings, care & maintenance and other useful informations.',
    btn: 'Contact To Download PDF'
}